
    import { Component, Vue } from 'vue-property-decorator';
    import { VBtn, VDivider, VListItem, VMenu } from 'vuetify/lib/components';
    import { MenuDivider, MenuItem, menu } from '@/components/Navigation/Menu';
    import { mapGetters } from 'vuex';
    import { AclModul, AclPermission } from '@/store/types';
    import {SystemEinstellung, SystemEinstellungKey} from '@/types/Einstellung';

    @Component({
        components: {
            VBtn,
            VDivider,
            VListItem,
            VMenu,
        },
        computed: {
          ...mapGetters('authentication', ['getSystemEinstellung', 'isAllowed']),
        },
    })
    export default class Navigation extends Vue {
        public isAllowed!: (moduleName: AclModul, permission: AclPermission | AclPermission[]) => boolean;
        public getSystemEinstellung!: <T>(parameter: SystemEinstellungKey) => SystemEinstellung<T>;

        public menu: ReadonlyArray<MenuItem> = [];

        public get $this(): Vue {
            return this;
        }

        public mounted(): void {
            this.menu = menu;
        }

        public hasChildren(item: MenuItem): boolean {
            return (item.children?.length ?? 0) > 0;
        }

        public renderChild(child: MenuItem | MenuDivider): boolean {
            if ((child as MenuDivider).divider) {
                return false;
            }

            const item = child as MenuItem;

            const rolleAnwenderReduziert = item.rolleAnwenderReduziert;

            if (item.permissions && rolleAnwenderReduziert && this.getSystemEinstellung('rolle_anwender_reduziert').isEnabled()) {
                if (item.permissions[0] === 'ivs') {
                    item.permissions[0] = 'admin';
                }
            }

            return (!item.permissions || this.isAllowed(...item.permissions)) &&
                (!item.show || item.show());
        }

        public renderDivider(childIndex: number, children?: (MenuItem | MenuDivider)[]): boolean {
            return children?.slice(childIndex).some((child) => this.renderChild(child)) ?? false;
        }

        public goto(route: string): void {
            this.$emit('goto', route);

            if (this.$router.currentRoute.path !== route) {
                this.$router.push(route);
            }
        }
    }
